<app-status-indicator
  [messageStatuses]="messageStatuses"
  [statusIndicatorButtonId]="_statusIndicatorButtonId"
  [statusIndicatorSpanId]="_statusIndicatorSpanId">
</app-status-indicator>
